<template>
  <div class="tinymce-editor">
    <editor v-model="myValue"
      :init="init"
      :disabled="disabled"
      @onClick="onClick">
    </editor>
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce'
import 'tinymce/skins/ui/oxide/skin.min.css'
import 'tinymce/skins/ui/oxide/content.inline.min.css'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/icons/default/icons.min.js'
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import 'tinymce/plugins/image'// 插入上传图片插件
import 'tinymce/plugins/media'// 插入视频插件
import 'tinymce/plugins/table'// 插入表格插件
import 'tinymce/plugins/lists'// 列表插件
import 'tinymce/plugins/wordcount'// 字数统计插件
import { 
    tinymceImgUpload
} from '../../api/index';
export default {
  components: {
    Editor
  },
  props: { 
    tinymceHeight: {
      type: Number,
      default: 500
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    font_formats: {
      type: [String, Array],
      default: '微软雅黑=Microsoft YaHei,Helvetica Neue;PingFang SC;sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun;serifsans-serif;Terminal=terminal;monaco;Times New Roman=times new roman;times'
    },
    plugins: {
      type: [String, Array],
      default: 'lists image media table wordcount'
    },
    toolbar: {
      type: [String, Array],
      default: 'undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat'
    }
  },
  data () {
    return {
      init: {
        // language_url: '/tinymce/langs/zh_CN.js',
        // language_url: '/tinymce/langs/hy.js',
        // language: 'zh_CN',
        // skin_url: '/tinymce/skins/ui/oxide',
        content_css: false,
        // skin_url: '/tinymce/skins/ui/oxide-dark',//暗色系
        height: this.tinymceHeight,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false, // 水印
        elementpath: true, //编辑器底部的状态栏
        statusbar: true, // 编辑器底部的状态栏
        paste_data_images: true, // 允许粘贴图像
        menubar: false, // 最上方menu
        lineheight_val: "1 1.5 1.6 1.75 1.8 2 3 4 5",
        automatic_uploads: true,
        fontsize_formats: "14px 16px 18px 20px 24px 26px 28px 30px 32px 36px", //字体大小
        font_formats: this.font_formats, //字体
        images_upload_handler: (blobInfo, success, failure) => {
          // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          // console.log(blobInfo,"blobInfo")
          // console.log(success,"success")
          // console.log(failure,"failure")
          // success(img)
          let formData = new FormData()
          // 服务端接收文件的参数名，文件数据，文件名
          // formData.append('position', 1)
          formData.append('file', blobInfo.blob(), blobInfo.filename())
          let token = localStorage.getItem("userToken")
          tinymceImgUpload(token,formData).then(res => {
            if(res.status == 200) {
              success(res.data)
            }else {
              console.log(failure)
            }
          }).catch(error => {
            console.log(error);
          });
        }
      },
      myValue: this.value
    }
  },
  mounted () {
    tinymce.init({})
  },
  methods: {
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick (e) {
      this.$emit('onClick', e, tinymce)
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear () {
      this.myValue = ''
    }
  },
  watch: {
    value (newValue) {
      this.myValue = newValue
    },
    myValue (newValue) {
      this.$emit('input', newValue)
    }
  }
}

</script>